export class Repeatcontent {
  listContents: any[] = [];
}
